const subscribers = {};

function subscribe(eventName, callback) {
	if (subscribers[eventName] === undefined) {
		subscribers[eventName] = [];
	}

	subscribers[eventName] = [...subscribers[eventName], callback];

	return function unsubscribe() {
		subscribers[eventName] = subscribers[eventName].filter(cb => {
			return cb !== callback;
		});
	};
}

function publish(eventName, data) {
	if (!Array.isArray(subscribers[eventName])) {
		return;
	}

	subscribers[eventName].forEach(callback => {
		try {
			callback(data);
		} catch (error) {
			console.error("Error in event subscriber:", error);
		}
	});
}
